<template>
    <div class="pp-lottery-winnings">
        <h2 class="pp-lottery-winnings__title">Kombinace (např. 6 nebo 36, 9 nebo 33, apod.)</h2>
        <DsTable>
            <DsRow>
                <DsCell type="th">Tipovaná kombinace</DsCell>
                <DsCell type="th">Výherní násobek</DsCell>
            </DsRow>
            <DsRow v-for="(sum, index) in winningSum" :key="index">
                <DsCell>{{ getCombinationText(sum) }}</DsCell>
                <DsCell><strong v-html="formatMultiple(sum[2])"></strong></DsCell>
            </DsRow>
        </DsTable>
        <h2 class="pp-lottery-winnings__title">Kombinace (např. šestice, pětice, apod.)</h2>
        <DsTable>
            <DsRow>
                <DsCell type="th">Tipovaná kombinace</DsCell>
                <DsCell type="th">Výherní násobek</DsCell>
            </DsRow>
            <DsRow v-for="(combination, index) in winningCombinations" :key="index">
                <DsCell>{{ combination[0] }}</DsCell>
                <DsCell><strong v-html="formatMultiple(combination[1])"></strong></DsCell>
            </DsRow>
        </DsTable>
    </div>
</template>
<script lang="ts" setup>
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";

const getCombinationText = (numbers: number[]) => {
    let text = `${numbers[0]}`;
    if (numbers[1]) text += ` nebo ${numbers[1]}`;
    return text;
};

const winningSum = [
    [6, 36, 25000],
    [7, 35, 4400],
    [8, 34, 1250],
    [9, 33, 474],
    [10, 32, 210],
    [11, 31, 105],
    [12, 30, 55],
    [13, 29, 35],
    [14, 28, 22],
    [15, 27, 15],
    [16, 26, 12],
    [17, 25, 9],
    [18, 24, 8],
    [19, 23, 7],
    [20, 22, 6],
    [21, null, 6],
];

const winningCombinations: [string, number][] = [
    ["jedničky", 25000],
    ["dvojky", 25000],
    ["trojky", 25000],
    ["čtyřky", 25000],
    ["pětky", 25000],
    ["šestky", 25000],
    ["šestice", 4400],
    ["pětice", 147],
    ["čtveřice", 12],
    ["2x trojice", 88],
    ["3x dvojice", 14],
    ["1;2;3;4;5;6", 36],
    ["2;4;6", 36],
    ["1;3;5", 36],
    ["1;2;3", 36],
    ["4;5;6", 36],
];

const formatMultiple = (multiple: number) => `${StringUtils.formatNumber(multiple)}x`;
</script>
